import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faUserGraduate from '@fortawesome/fontawesome-pro-light/faUserGraduate';
import faCalendarAlt from '@fortawesome/fontawesome-pro-light/faCalendarAlt';
import faBookOpen from '@fortawesome/fontawesome-pro-light/faBookOpen';
import './Sidebar.css';

const Sidebar = () => {
  let phJourneyBlocks = [
    {
      title: 'Find our Next Student Fair',
      link: 'https://aspph.org/events/category/student-recruitment/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-find-your-career.png',
    },
    {
      title: 'Explore Public Health',
      link: 'https://thisispublichealth.aspph.org/areas-of-study/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-explore-public-health.png',
    },
    {
      title: '10 Things to Know Before You Apply',
      link: 'https://thisispublichealth.aspph.org/10-things-to-know/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-things-to-know-before-applying.png',
    },
    {
      title: 'Apply to Graduate School',
      subtext: 'SOPHAS.ASPPH.org',
      link: 'https://sophas.aspph.org',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-apply-to-graduate-school.png',
    },
    {
      title: 'Finance Your Degree',
      link: 'https://thisispublichealth.aspph.org/financing-your-degree/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-finance-your-degree.png',
    },
    {
      title: 'Build Your Skills',
      link: 'https://thisispublichealth.aspph.org/students/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-build-your-skills.png',
    },
    {
      title: 'Find Your Career',
      link: 'https://publichealthjobs.aspph.org/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-find-your-career.png',
    },
    {
      title: 'Continue Life-Long Learning',
      link: 'https://www.nbphe.org/',
      image: 'https://aspphwebassets.s3.amazonaws.com/apf/Icons-continue-life-long-learning.png',
    },
  ];

  return (
    <div className="Sidebar">
      <section className="Sidebar--logo-highlights Sidebar--latest-news">
        <div className="iframe-wrapper ">
          <iframe
            id="myFrame"
            src="https://pardot.aspph.org/l/497911/2023-08-09/w431l"
            height="400"
            type="text/html"
            frameborder="0"
            // scrolling="no"
            allowTransparency="true"
          ></iframe>
        </div>
      </section>

      <section className="Sidebar--student-journey">
        <h3 className="Sidebar--title">Public Health Student Journey</h3>

        <div class="vertical-line">
          {phJourneyBlocks.map((block) => (
            <div className="timeline-row">
              <img src={block.image}></img>
              <div className="timeline-text">
                <a href={block.link} target="_blank">
                  {block.title}
                  <span className="Sidebar--subtext"> {block.subtext ? block.subtext : ''}</span>
                </a>
              </div>

              <hr />
            </div>
          ))}

          {/* <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div>
          <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div>
          <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div>
          <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div>
          <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div>
          <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div>
          <div className="timeline-row">
            <img src="http://aspph2-wp-production.s3.us-east-1.amazonaws.com/wp-content/uploads/2022/03/Icons-17.png"></img>
            <div className="timeline-text">Explore Public Health</div>
          </div> */}
        </div>
      </section>

      {/* <section className="Sidebar--highlights">
    </section> */}
    </div>
  );
};

export default Sidebar;
